// @import dependencies
// @end

// @import event types
import { AuthActionTypes, CHANGE_SCREEN_MODE, IUserState, LOGIN, LOGOUT, MOODLE_AUTH, MOODLE_FORM_REQUEST, UPDATE_TOKEN, UPDATE_USER_DATA, UPDATE_USER_STORE } from './types';
// @end

const initialState: IUserState = {
  user: null,
  isAuth: false,
  moodleAuth: false,
  moodleFormRequest: false
}

export function authReducer(
  state = initialState,
  action: AuthActionTypes,
): IUserState {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
        isAuth: true
      }
    case LOGOUT:
      return {
        ...state,
        user: null,
        isAuth: false,
        moodleAuth: false,
        moodleFormRequest: false
      }
    case UPDATE_TOKEN: {
      return {
        ...state,
        user: {
          ...state.user,
          token: action.payload,
        }
      }
    }
    case UPDATE_USER_DATA: {
      return {
        ...state,
        user: {
          ...state.user,
          data: action.payload
        }
      }
    }
    case UPDATE_USER_STORE: {
      return {
        ...state,
        user: action.payload
      }
    }
    case CHANGE_SCREEN_MODE:
      return {
        ...state,
        user: action.payload,
      }
    case MOODLE_AUTH: {
      return {
        ...state,
        moodleAuth: action.payload
      }
    }
    case MOODLE_FORM_REQUEST: {
      return {
        ...state,
        moodleFormRequest: action.payload
      }
    }
    default:
      return state
  }
}
